import { render, staticRenderFns } from "./CloseCaseDialog.vue?vue&type=template&id=2c04299a&"
import script from "./CloseCaseDialog.vue?vue&type=script&lang=js&"
export * from "./CloseCaseDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports